export const POSTHOG_SENSITIVE_MASK_CLASS = "ph-mask";

/** @deprecated Prefer {@link POSTHOG_SENSITIVE_MASK_CLASS} — kept for script editor imports. */
export const SCRIPT_EDITOR_ROOT_MASK_CLASS = POSTHOG_SENSITIVE_MASK_CLASS;

export const COVERAGE_ANALYSIS_SENSITIVE_CLASS = "coverage-analysis-sensitive";

export const SCRIPT_NOTES_SENSITIVE_CLASS = "script-notes-sensitive";

export const SCRIPT_REPORT_SENSITIVE_CLASS = "script-report-sensitive";

export const CHARACTER_BREAKDOWN_SENSITIVE_CLASS = "character-breakdown-sensitive";

export const SCRIPT_BREAKDOWN_SENSITIVE_CLASS = "script-breakdown-sensitive";

export const POSTHOG_SESSION_RECORDING_OPTIONS = {
  maskAllInputs: true,
  maskTextSelector: [
    ".ph-mask",
    "[data-ph-mask]",
    ".script-editor-root",
    ".script-editor-root .ProseMirror",
    '.script-editor-root [contenteditable="true"]',
    ".script-screenplay-paper",
    `.${COVERAGE_ANALYSIS_SENSITIVE_CLASS}`,
    `.${SCRIPT_NOTES_SENSITIVE_CLASS}`,
    `.${SCRIPT_REPORT_SENSITIVE_CLASS}`,
    `.${CHARACTER_BREAKDOWN_SENSITIVE_CLASS}`,
    `.${SCRIPT_BREAKDOWN_SENSITIVE_CLASS}`,
  ].join(", "),
  blockSelector: "[data-ph-no-capture]",
} as const;
